import IDivideByPricing from "../contracts/IDivideByPricing";
import PricingHandler from "../contracts/PricingHandler";

/**
 * Calculates price per uom (unit of measure) price and quantity.
 *
 * @param input
 * @param resolvedPricing
 */
const divideByHandler: PricingHandler<IDivideByPricing> = (
  input,
  resolvedPricing,
) => {
  if (!input.divideByUnit || !input.divideByQuantity) return resolvedPricing;

  return {
    ...resolvedPricing,
    metadata: {
      ...resolvedPricing.metadata,
      divideBy: {
        unitOfMeasure: input.divideByUnit,
        price: resolvedPricing.price / input.divideByQuantity,
      },
    },
  };
};

export default divideByHandler;
